import { FirestoreDataConverter } from "firebase/firestore";
import { omitBy } from "lodash";
import moment from "moment";
import UploadInternacional from "../models/uploadInternacional";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class UploadInternacionalDb extends BaseDb<
  UploadInternacional,
  { usuarioId: string; uploadId: string }
> {
  _path: string = "usuarios/usuarioId/uploadsInternacionais/uploadId";

  getConverter(): FirestoreDataConverter<UploadInternacional> {
    return {
      fromFirestore: (snapshot, _options) => {
        const baseProps = {
          id: snapshot.id,
          situacao: snapshot.get("situacao"),
          nomeArquivoOriginal: snapshot.get("nomeArquivoOriginal"),
          dataUpload: snapshot.get("dataUpload")
            ? moment(snapshot.get("dataUpload").toDate())
            : undefined,
          arquivo: snapshot.get("arquivo"),
          periodo: snapshot.get("periodo")
            ? {
                de: moment(snapshot.get("periodo").de.toDate()),
                a: moment(snapshot.get("periodo").a.toDate()),
              }
            : undefined,
          instituicao: snapshot.get("instituicao"),
          operacoesImportadas: snapshot.get("operacoesImportadas"),
          operacoesIgnoradas: snapshot.get("operacoesIgnoradas"),
        } as any;

        // Caso ainda existam operações brutas salvas no documento (antes de serem importadas),
        // convertemos para o modelo; caso contrário, mantemos undefined.
        const operacoesRaw = snapshot.get("operacoes");
        if (operacoesRaw) {
          baseProps.operacoes = operacoesRaw.map((op: any) => ({
            ...op,
            dataPregao: moment(op.dataPregao.toDate()),
          }));
        }

        // Caso seja documento de erro, adiciona o campo erro
        if (snapshot.get("erro")) {
          baseProps.erro = snapshot.get("erro");
        }

        return new UploadInternacional(baseProps);
      },
      toFirestore: (upload: UploadInternacional) =>
        toFirestore(omitBy(upload, ["id"])),
    };
  }
}
